import FindAgentBlock from '../components/FindAgentBlock';
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Slider from "react-slick";
import newsletterActions from '../store/actions/newsletter';
import {NewsletterImage} from "../components/NewsletterImage";

export const AboutNewsletter = () => {
  const newsletterStore = useSelector((store) => store.newsletterStore);
  const dispatch = useDispatch();
  const sliderRef = useRef(null);
  const thumbsRef = useRef(null);
  const testRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(0);
  let resizeWindow = () => {
    setWindowWidth(window.innerWidth);
  };

  function PrevArrow(props) {
    const { onClick } = props;
    return (
        <div className="newsletter-arrow prev" onClick={onClick}>
          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/newsletter/arrow-left.svg`} alt=""/>
        </div>
    );
  }
  function NextArrow(props) {
    const { onClick } = props;
    return (
        <div className="newsletter-arrow next" onClick={onClick}>
          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/newsletter/arrow-right.svg`} alt=""/>
        </div>
    );
  }


  const settingsSlider = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerMode: true,
          focusOnSelect: true,
          infinite: true,
          centerPadding: '0px',
        }
      },
    ]
  };

  const slidesToShow = () => {
    let count = 5;
    if (newsletterStore.newsletterList.length < count) {
      count = newsletterStore.newsletterList.length
    }
    return count
  }

  const settingsThumbs = {
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: true,
    centerPadding: '0px',
    focusOnSelect: true,
    touchMove: false,
    speed: 500,
    slidesToShow: slidesToShow(),
    slidesToScroll: 1,
  };

  const getDate = (date) => {
    const dateSplit = date.split('-');
    const year = dateSplit[0];
    let month;
    switch (dateSplit[1]) {
      case '01' : month = 'January';
        break;
      case '02' : month = 'February';
        break;
      case '03' : month = 'March';
        break;
      case '04' : month = 'April';
        break;
      case '05' : month = 'May';
        break;
      case '06' : month = 'June';
        break;
      case '07' : month = 'July';
        break;
      case '08' : month = 'August';
        break;
      case '09' : month = 'September';
        break;
      case '10' : month = 'October';
        break;
      case '11' : month = 'November';
        break;
      case '12' : month = 'December';
        break;
      default : break;
    }

    return `Rolnik, ${month} ${year}`
  }

  const newsletterSliderList = newsletterStore.newsletterList.map((elem) => {
    if (elem.isPublished > 0) {
      return (
          <div key={elem.id} className="newsletter-item">
            <a className="newsletter-item__link" href={elem.source} target="_blank">
              <div className="newsletter-item__image-wrapper">
                <div className="newsletter-item__image-overlay">
                  <div className="newsletter-item__btn">Click to Read</div>
                </div>
                <img src={elem.image.webPath} alt=""/>
                {/*<NewsletterImage link={elem.image.webPath}/>*/}
              </div>
              <div className="newsletter-item__date">{getDate(elem.publishDate)}</div>
            </a>
          </div>
      )
    }
  });
  const newsletterThumbsList = newsletterStore.newsletterList.map((elem) => {
    if (elem.isPublished > 0) {
      return (
          <div key={elem.id} className="newsletter-thumb">
            <img src={elem.image.webPath} alt=""/>
            {/*<NewsletterImage link={elem.image.webPath}/>*/}
          </div>
      )
    }
  });

  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    dispatch(newsletterActions.fetchNewsletters());
    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);


  return (
    <>
      <div className="about-newsletter-page" >
        <div className="title-main">
          Newsletter
        </div>
        <div className="subtitle">
          News and information from our Lodges and Home Office
        </div>
        <div className={`slider-wrapper ${newsletterStore.isLoading ? 'is-loading' : ''}`} ref={testRef}>
          <div className="newsletter-spinner"/>
          <Slider className="newsletter-slider" {...settingsSlider} ref={sliderRef} asNavFor={thumbsRef.current}>
            {newsletterSliderList}
          </Slider>
          <Slider className={`newsletter-thumbs slides-${slidesToShow()}`} {...settingsThumbs} ref={thumbsRef} asNavFor={sliderRef.current}>
            {newsletterThumbsList}
          </Slider>
        </div>
        <FindAgentBlock />
      </div>
    </>
  );
}
